<div class="sp-card kpi-stat-card" [ngClass]="cardClass">
  <p class="card-label" *ngIf="label">{{ label }}</p>
  <h2 class="card-value" [class.urgent]="variant === 'urgent' || isUrgent">
    <ng-container *ngIf="useDividePipe && isNumeric(value); else rawValue">
      {{ value | divide }}
    </ng-container>
    <ng-template #rawValue>
      {{ value ?? '0.00' }}
    </ng-template>
  </h2>
  <p
    class="card-subtext"
    [class.collection-pct]="percentage !== null && percentage !== undefined && percentage !== ''"
    *ngIf="subtext || (percentage !== null && percentage !== undefined && percentage !== '')"
  >
    <ng-container *ngIf="percentage !== null && percentage !== undefined && percentage !== ''; else plainSubtext">
      <span class="pct-value">{{ percentage }}%</span>
      <span class="pct-label">{{ percentageLabel || subtext }}</span>
    </ng-container>
    <ng-template #plainSubtext>
      {{ subtext }}
    </ng-template>
  </p>
  <ng-content></ng-content>
</div>
